import React from 'react';
import { Redirect } from 'react-router-dom';
import qs from 'qs';

import OrderLoading from '../../../components/common/molecules/OrderLoading';
import PageTemplate from '../../../components/common/template/PageTemplate';
import {
  Layout,
  OrderTemplate,
} from '../../../components/common/template/OrderTemplate';
import { NameMobileInputs } from '../Item/OrderInfoInput';
import { MYPAGE_COUPON_MENU } from '../../../lib/routes/MyPageRoutes';
import * as PATH from '../../../lib/routes/path';
import usePrePurchase from '../../../Hooks/order/usePrePurchase';

const PrePurchase = ({ location }) => {
  const query = qs.parse(location.search.substr(1));

  const {
    defaultPrice,
    finalShippingFee,
    finalPrice,
    buyerInfo,
    pg,
    pay_method,
    merchant_uid,
    isLoading,
    toCompletion,
    onChangeValue,
    onPaymentMethod,
    doSelectVoucherCoupon,
    createPrePurchaseOrder,
  } = usePrePurchase({ query });

  return (
    <>
      {toCompletion && <Redirect to={`${PATH.COMPLETION}/${merchant_uid}`} />}

      <PageTemplate title="베이비페이스 사전 구매">
        {isLoading ? (
          <OrderLoading />
        ) : (
          <OrderTemplate
            process={PRE_PURCHASE_GUIDES}
            pg={pg}
            pay_method={pay_method}
            onPayMethod={onPaymentMethod}
            onSelectVoucherCoupon={doSelectVoucherCoupon}
            defaultPrice={defaultPrice}
            finalShippingFee={finalShippingFee}
            finalPrice={finalPrice}
            onCheck={createPrePurchaseOrder}
            discountPrice={defaultPrice - (finalPrice - finalShippingFee)}
            couponOnly={true}
          >
            <Layout title="3. 신청자정보" required>
              <NameMobileInputs state={buyerInfo} onChange={onChangeValue} />
            </Layout>
          </OrderTemplate>
        )}
      </PageTemplate>
    </>
  );
};

export default PrePurchase;

const PRE_PURCHASE_GUIDES = {
  title: <b>사전 구매 쿠폰 프로세스</b>,
  description: [
    '- 언제든 환불 가능! (1년 이내)',
    `- 사전 구매 쿠폰은 <b>${MYPAGE_COUPON_MENU.label}</b>에 자동등록 됩니다 (가상계좌는 결제 후 직접 등록)`,
    '- 베이비페이스 신청 시 [상품권/쿠폰] 에서 적용해주세요.',
  ],
};
